export default __webpack_public_path__ + "static/media/logo.16b48d6b.svg";